/* ------------------------------------------------------------
   V3 Homepage — Video block playback
   ------------------------------------------------------------
   Two jobs the native <video> attributes can't do:

   1. Play on ENTER VIEWPORT, not on page load. The native `autoplay`
      attribute fires as soon as the file can play, even if the block
      is three screens down — so by the time you scroll to it, it has
      already run. An IntersectionObserver starts it when it actually
      comes into view and pauses it on the way out.

   2. Play a FIXED NUMBER OF TIMES (1 or 3). `loop` is all-or-nothing,
      so we count `ended` events and replay until the quota is met.
      The count is per page view — once it has played its N times it
      stays on its last frame, even if you scroll back to it.

   Reduced motion is honoured: no autoplay, controls shown instead.
   ------------------------------------------------------------ */
(function () {
  if (window.__v3homeVideoInit) return;
  window.__v3homeVideoInit = true;

  var reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(video) {
    if (video.__akBound) return;
    video.__akBound = true;

    var autoplay = video.getAttribute('data-autoplay') === 'true';
    var mode = video.getAttribute('data-play-count') || 'loop';

    // Someone asked not to be moved at. Give them a poster + controls.
    if (!autoplay || reduceMotion) {
      video.setAttribute('controls', '');
      return;
    }

    if (mode === 'loop') {
      video.loop = true;
    } else {
      var max = parseInt(mode, 10) || 1;
      var plays = 0;
      var finished = false;

      video.addEventListener('ended', function () {
        plays += 1;
        if (plays < max) {
          video.currentTime = 0;
          video.play().catch(function () {});
        } else {
          finished = true;
        }
      });

      video.__isFinished = function () {
        return finished;
      };
    }

    if (!('IntersectionObserver' in window)) {
      video.play().catch(function () {});
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (video.__isFinished && video.__isFinished()) return;
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      // Needs a decent chunk on screen before it starts — firing at 1px
      // means it plays while still effectively off-screen.
      { threshold: 0.35 }
    );

    io.observe(video);
  }

  function init() {
    var vids = document.querySelectorAll('video[data-ak-video]');
    Array.prototype.forEach.call(vids, setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders the section on every setting change.
  document.addEventListener('shopify:section:load', init);
})();
